class Reviews {
    constructor(el) {
        this.container = $(el);
        this.reviews = this.container.find('.js-reviews-item');
        this.offsetInput = this.container.find('.js-input-offset');
        this.trigger = $('.js-reviews-more');
        this.moreUrl = this.container.data('url');

        this.showClick();

        if (this.trigger) {
            this.bindBtnMore();
        }
    }

    showClick() {
        App.D.on('click', '.js-review-show', function() {
            let $link = $(this);
            let $text = $link.parents('.js-reviews-item').find('.js-review-text');

            if ($text.hasClass('_is-open')) {
                $text.removeClass('_is-open');
                $link.text($link.data('more-text'));
            } else {
                $text.addClass('_is-open');
                $link.text($link.data('less-text'));
            }
        });
    }

    /**
     * Подгрузка отзывов
     */
    bindBtnMore() {
        this.trigger.on('click', () => {
            this.loadMore();
        });
    }
    
    loadMore() {
        this.offsetInput.value = this.container.find('.js-reviews-item').length;
        this.offsetInput.disabled = false;
        this.trigger.addClass('_is-active');

        /**
         * Грузим
         */
        $.ajax({
            url: this.moreUrl,
            type: this.container.data('method') || 'GET',
            data: {
                'offset': this.offsetInput.value
            },
            success: (response) => {
                if (response) {
                    /**
                     * Вытаскиваем разметку из ответа
                     */
                    const tmp = document.createElement('div');
                    tmp.innerHTML = response;
                    const inner = tmp.querySelector('[data-html]');

                    if (!inner) return;

                    /**
                     * Добавляем карточки в каталог
                     */
                    this.container.append(inner.innerHTML);

                    /**
                     * Если есть маркер, что это последние элементы,
                     * отключаем триггер
                     */
                    if (inner.getAttribute('data-last') === 'true') {
                        this.trigger.css('display', 'none');
                    }
                } else {
                    console.log('Ошибка получения каталога');
                }

                this.trigger.removeClass('_is-active');
                this.offsetInput.disabled = true;
            },
            error: () => {
                console.log('Ошибка на сервере');
                this.trigger.removeClass('_is-active');
                this.offsetInput.disabled = true;
            }
        });
    }
}

$('.js-reviews').each(function(ind, el) {
    new Reviews(el);
});



// WEBPACK FOOTER //
// ./_src/js/Reviews.js